<template>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Configuraciones</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Usuarios</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Usuarios
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="mt-3 lg:mt-0">
        <Button
          v-if="'Usuario Crear' in auth.user.permissions"
          label="NUEVO USUARIO"
          class="p-button-outlined mr-2"
          icon="pi pi-plus"
          v-tooltip.top="'Nuevo Usuario'"
          @click="openNuevo"
        ></Button>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dtusers"
        :value="users"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Useres"
        responsiveLayout="scroll"
        showGridlines
        selectionMode="single"
        @row-dblclick="editUser($event.data)"
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="buscar['global'].value" placeholder="Buscar..." />
            </span>
          </div>
        </template>

        <template #loading> Se estan buscando los Usuarios, por favor espere! </template>

        <template #empty> No existen Usuarios! </template>

        <Column field="id" header="CÓDIGO" :sortable="true">
          {{ data.id }}
        </Column>
        <Column field="name" header="NOMBRE" :sortable="true"></Column>

        <Column field="username" header="USERNAME" :sortable="true">
          <template #body="{ data }">
            <span style="background-color: #e0e0e0; padding: 4px 8px; border-radius: 4px">{{ data.username }}</span>
          </template>
        </Column>

        <Column field="email" header="CORREO">
          <template #body="{ data }">
            {{ data.email }}
          </template>
        </Column>

        <Column field="phone" header="TELÉFONO">
          <template #body="{ data }">
            {{ data.phone || '-' }}
          </template>
        </Column>
        <Column field="roles" header="ROLES DE USUARIO">
          <template #body="{ data }">
            <span class="product-badge bg-blue-400 mr-1 text-white" v-for="(rol, index) in data.roles" :key="index">
              {{ rol }}
            </span>
          </template>
        </Column>
        <Column field="created_at" header="FECHA DE CREACIÓN" v-if="false">
          <template #body="{ data }">
            {{ formatDate(data.created_at) }}
          </template>
        </Column>
        <Column headerStyle="min-width:10rem;" header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              icon="pi pi-ellipsis-v"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)"> </Menu>
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      v-model:visible="userDialog"
      :style="{ width: '450px' }"
      header="Usuario Detalle"
      :modal="true"
      class="p-fluid"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-12">
            <strong>NOMBRE COMPLETO: </strong>
            <span class="p-invalid">*</span>
            <InputText v-model.trim="user.name" required="true" autofocus autocomplete="name" />
            <small class="p-invalid" v-if="errors.name">{{ errors.name[0] }}</small>
          </div>

          <div class="field col-12 md:col-7">
            <strong>USUARIO: </strong>
            <div class="p-inputgroup">
              <InputText
                v-model.trim="user.username"
                placeholder="Se auto-generará si se deja vacío"
                @input="user.username = user.username ? user.username.toLowerCase() : ''"
                autocomplete="off"
              />
              <Button
                icon="pi pi-refresh"
                class="p-button-secondary"
                v-tooltip.top="'Auto-generar desde nombre'"
                @click="generarUsername"
                type="button"
              />
            </div>
            <small class="p-text-secondary">Formato: solo letras, números, puntos, guiones</small>
            <br />
            <small class="p-invalid" v-if="errors.username">{{ errors.username[0] }}</small>
          </div>

          <div class="field col-12 md:col-5">
            <strong>CONTRASEÑA: </strong>
            <span class="p-invalid" v-if="!user.id">*</span>
            <InputText
              id="password"
              v-model="user.password"
              type="password"
              autocomplete="new-password"
              :placeholder="user.id ? 'Dejar vacío para no cambiar' : 'Mínimo 8 caracteres'"
            />
            <small class="p-invalid" v-if="errors.password">{{ errors.password[0] }}</small>
          </div>

          <div class="field col-12 md:col-7">
            <strong>CORREO ELECTR&Oacute;NICO: </strong>
            <InputText id="email" v-model="user.email" type="email" autocomplete="email" placeholder="Opcional" />
            <small class="p-text-secondary">Opcional - Se auto-generará si se deja vacío</small>
            <br />
            <small class="p-invalid" v-if="errors.email">{{ errors.email[0] }}</small>
          </div>

          <div class="field col-12 md:col-5">
            <strong>TELÉFONO: </strong>
            <InputText
              id="phone"
              v-model="user.phone"
              placeholder="Ej: 69149458 o +59169149458"
              type="tel"
              autocomplete="tel"
              @blur="formatearTelefono"
            />
            <small class="p-text-secondary">Se agregará 591 automáticamente si es necesario</small>
          </div>

          <div class="field col-12 md:col-12">
            <strong>ROL DE USUARIO: </strong>
            <span class="p-invalid">*</span>
            <MultiSelect
              id="roles"
              v-model="user.roles"
              :options="roles"
              optionLabel="name"
              placeholder="Seleccione Roles"
              display="chip"
            />
            <small class="p-invalid" v-if="!user.roles">Se necesita rol.</small>
          </div>

          <div class="field col-12 md:col-12">
            <strong>ADMINISTRAR SUCURSAL:</strong>
            <div class="p-inputgroup">
              <AutoComplete
                field="nombre"
                v-model="sucursalSelected"
                :suggestions="sucursales"
                placeholder="Buscar Sucursal"
                v-tooltip.top="'Buscar Sucursal'"
                @complete="buscarSucursal($event)"
                @keyup.enter="buscarSucursal()"
                autocomplete="off"
              >
                <template #item="slotProps">
                  <div>
                    <strong>{{ slotProps.item.nombre }}</strong>
                  </div>
                </template>
              </AutoComplete>
              <Button
                icon="pi pi-search"
                class="p-button-warning"
                v-tooltip.top="'Buscar Sucursal'"
                @click="buscarSucursal()"
                type="button"
              />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="field">
          <label class="flex md:justify-content-start"
            ><strong>CAMPOS REQUERIDOS: </strong> <span class="p-invalid">*</span></label
          >
        </div>
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-secondary p-button-lg"
          @click="ocultarDialog"
          :disabled="!enviado ? false : true"
        />
        <Button
          :label="user.id ? 'ACTUALIZAR' : 'GUARDAR'"
          :icon="user.id ? 'pi pi-pencil' : 'pi pi-save'"
          class="p-button-primary p-button-lg"
          @click="guardarUser"
          :disabled="!enviado ? false : true"
          :loading="enviado"
        />
      </template>
    </Dialog>

    <Dialog v-model:visible="deleteUserDialog" :style="{ width: '450px' }" header="Confirmar" :modal="true">
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="user"
          >Estas Seguro que quieres eliminar Usuario <b>{{ user.name }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-secondary" @click="deleteUserDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-primary" @click="deleteUser" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import UserService from '@/service/UserService'
import RolService from '@/service/RolService'
import { useAuth } from '@/stores'

export default {
  data() {
    return {
      users: null,
      cargando: true,
      userDialog: false,
      deleteUserDialog: false,
      user: {},
      buscar: {},
      enviado: false,
      roles: {},
      errors: {},
      totalRegistros: 0,
      sucursalSelected: 0,
      sucursales: []
    }
  },
  userService: null,
  rolService: null,
  auth: null,
  created() {
    this.auth = useAuth()
    this.userService = new UserService()
    this.rolService = new RolService()
    this.initBuscar()
  },
  mounted() {
    this.cargarUsuarios()

    this.rolService.getRolesAll().then((roles) => {
      this.roles = roles
    })
  },
  methods: {
    formatearTelefono() {
      if (!this.user.phone) return

      let telefono = this.user.phone.trim()
      telefono = telefono.replace(/\+/g, '')
      telefono = telefono.replace(/[^0-9]/g, '')

      if (telefono.length === 8) {
        telefono = '591' + telefono
      }

      this.user.phone = telefono
    },
    generarUsername() {
      if (!this.user.name) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Primero ingresa el nombre completo',
          life: 3000
        })
        return
      }

      const palabras = this.user.name.trim().split(' ')
      let username = ''

      if (palabras.length > 1) {
        palabras.forEach((palabra) => {
          if (palabra) {
            username += palabra[0].toLowerCase()
          }
        })
      } else {
        username = this.user.name.substring(0, 4).toLowerCase()
      }

      username = username.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      username = username.replace(/[^a-z0-9._-]/g, '')

      this.user.username = username

      this.$toast.add({
        severity: 'success',
        summary: 'Username generado',
        detail: `Username: ${username}`,
        life: 3000
      })
    },

    buscarSucursal() {
      let datos = {
        texto: this.sucursalSelected ? this.sucursalSelected : null
      }
      this.userService.buscar_sucursal_user(datos).then((response) => {
        if (response.status == 400 || response.sucursales.length == 0) {
          this.$toast.add({
            severity: 'error',
            summary: 'ERROR',
            detail: 'No se encontró el cliente',
            life: 3000
          })
          return
        }
        this.sucursales = [...response.sucursales]
      })
    },
    cargarUsuarios() {
      this.userService.getUsersAll().then((data) => {
        this.users = data
        this.cargando = false
        this.users.forEach((user) => {
          let rolesName = new Array()
          user.roles.forEach((rol) => {
            rolesName.push(rol.name.toLowerCase())
          })
          user.roles = rolesName
          user.created_at = new Date(user.created_at)
          user.updated_at = new Date(user.updated_at)
        })
      })
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions
      return [
        {
          label: 'Editar',
          disabled: 'Usuario Editar' in permisosUsuarioAuth ? false : true,
          icon: 'pi pi-pencil',
          command: () => {
            this.editUser(datos)
          }
        },
        {
          label: 'Eliminar',
          disabled: 'Usuario Eliminar' in permisosUsuarioAuth ? false : true,
          icon: 'pi pi-trash',
          command: () => {
            this.confirmDeleteUser(datos)
          }
        }
      ]
    },
    openNuevo() {
      this.user = {}
      this.enviado = false
      this.userDialog = true
    },
    ocultarDialog() {
      this.errors = {}
      this.userDialog = false
      this.enviado = false
      this.user = {}
      this.sucursalSelected = 0
      this.sucursales = []
    },
    guardarUser() {
      this.errors = {}
      this.enviado = true

      if (this.user.id) {
        let user_enviar = {
          ...this.user,
          sucursal_id: this.sucursalSelected ? this.sucursalSelected.id : null
        }

        this.userService.updatedUser(user_enviar).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, 'errors')) {
            this.errors = data.errors
          } else {
            this.errors = {}

            let aux = { ...data.user }
            let rolesName = new Array()
            aux.roles.forEach((rol) => {
              rolesName.push(rol.name.toLowerCase())
            })
            aux.roles = rolesName

            aux.created_at = new Date(aux.created_at)
            aux.updated_at = new Date(aux.updated_at)

            this.users[this.findIndexById(aux.id)] = aux

            this.$toast.add({
              severity: 'success',
              summary: 'Éxito!',
              detail: 'Usuario Actualizado',
              life: 3000
            })
            this.ocultarModalUser()
          }
          this.enviado = false
        })
      } else {
        let user_enviar = {
          ...this.user,
          sucursal_id: this.sucursalSelected ? this.sucursalSelected.id : null
        }

        this.userService.sendUserNuevo(user_enviar).then((response) => {
          if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
            this.errors = response.errors
          } else {
            this.errors = {}

            let user = response.user
            let rolesName = new Array()
            user.roles.forEach((rol) => {
              rolesName.push(rol.name.toLowerCase())
            })
            user.roles = rolesName
            user.created_at = new Date(user.created_at)
            user.updated_at = new Date(user.updated_at)
            this.users.push(user)

            let detalles = []

            if (response.username_generado) {
              detalles.push(`Username: ${user.username}`)
            }

            if (response.email_generado) {
              detalles.push(`Email: ${user.email}`)
            }

            let mensaje = 'Usuario creado correctamente'
            if (detalles.length > 0) {
              mensaje += '\n\nAuto-generado:\n' + detalles.join('\n')
            }

            this.$toast.add({
              severity: 'success',
              summary: '¡Éxito!',
              detail: mensaje,
              life: 6000
            })

            this.ocultarModalUser()
          }
          this.enviado = false
        })
      }
    },
    ocultarModalUser() {
      this.userDialog = false
      this.user = {}
      this.sucursalSelected = 0
      this.sucursales = []
    },
    editUser(user) {
      this.user = { ...user }
      this.user.roles = this.roles.filter((rol) => {
        return user.roles.includes(rol.name.toLowerCase())
      })
      this.sucursalSelected = user.sucursal_id ? { id: user.sucursal_id, nombre: user.sucursal.nombre } : null
      this.userDialog = true
    },
    confirmDeleteUser(user) {
      this.user = { ...user }
      this.deleteUserDialog = true
    },
    deleteUser() {
      this.userService.deleteUser(this.user).then((data) => {
        if (data.status == 200) {
          this.$toast.add({
            severity: 'success',
            summary: 'Exito!',
            detail: data.mensaje,
            life: 3000
          })
          this.cargarUsuarios()
          this.deleteUserDialog = false
          this.user = {}
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error!',
            detail: data.mensaje,
            life: 3000
          })
          this.deleteUserDialog = false
        }
      })
    },
    findIndexById(id) {
      let index = -1
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id === id) {
          index = i
          break
        }
      }
      return index
    },
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      }
    },
    /* verDetalle(user){
				this.$router.push(`/user/${user.id}/detalle`); 
		}, */
    formatDate(value) {
      return value.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      })
    }
  },
  watch: {
    users() {
      this.totalRegistros = this.users.length
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>
